import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import { ROUTE } from '../config'
import BreadCrumb from './BreadCrumb'
import {
  buildOwnersManualBreadcrumbTrail,
  getBrowseRootBreadcrumb,
} from '../extras/buildBrowseGuideBreadcrumbs'
import { buildSearchOriginBreadcrumbs } from '../extras/browseSearchOrigin'

class AutoBreadCrumb extends Component {
  static propTypes = {
    foldersIndex: ImmutablePropTypes.map.isRequired,
    activeFolder: PropTypes.object,
    rootFolderResourceKey: PropTypes.string.isRequired,
    baseRoute: PropTypes.string.isRequired,
    currentTopic: PropTypes.object,
    inactive: PropTypes.bool,
    searchOrigin: PropTypes.shape({
      query: PropTypes.string.isRequired,
      returnPath: PropTypes.string.isRequired,
    }),
  }

  render() {
    const {
      activeFolder,
      baseRoute,
      foldersIndex,
      rootFolderResourceKey,
      currentTopic,
      searchOrigin,
    } = this.props

    if (searchOrigin && currentTopic) {
      return (
        <BreadCrumb
          items={buildSearchOriginBreadcrumbs(searchOrigin, currentTopic.get('title'))}
          variant="browse-guide"
        />
      )
    }

    const folderItems = buildOwnersManualBreadcrumbTrail(
      activeFolder,
      foldersIndex,
      baseRoute,
      rootFolderResourceKey
    )

    const items = [getBrowseRootBreadcrumb(baseRoute), ...folderItems]

    if (currentTopic) {
      const topicKey = currentTopic.get('resourceKey')
      items.push({
        title: currentTopic.get('title'),
        link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.TOPIC}/${encodeURIComponent(topicKey)}`,
      })
    }

    if (items.length) {
      items[items.length - 1] = { title: items[items.length - 1].title, link: '' }
    }

    return <BreadCrumb items={items} variant="browse-guide" />
  }
}

export default AutoBreadCrumb
